<template>
	<div class="setting-page order  top-bar-page all-order page-padding-top">
		<top-bar :title="i18n.t('allOrder.title2')" @back="back"></top-bar>


		<div class="order-list">
			<!--现货-->
				<div class="trade-list" v-if="tabIndex == 1">
					<div class="list" >
						<div class="flex-center-between">
							<div>
								<div class="list-title flex-center-start">
									<span>{{detailData.Currency.ShortName}}/USDT</span>
									<span class="tab" :class="detailData.Trade == 'buy' ? 'green' : 'red'">{{detailData.Trust == 'limit' ? i18n.t('trade.label22') : i18n.t('trade.label21')}}-{{detailData.Trade == 'buy' ? i18n.t('trade.buy1') : i18n.t('trade.sell1')}}</span>
								</div>
								
							</div>
							<div class="cancel-btn flex-center" v-if="detailData.Status == 0" @click.stop="cancelOrder(detailData)">
								<img :src="clearUrl" alt="">
								<span >{{ i18n.t('trade.status3')}}</span>
							</div>
						</div>

						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th1')}}</div>
							<div>{{parseFloat(detailData.TrustClose).toFixed(4)}} USDT</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th4')}}</div>
							<div>{{parseFloat(detailData.TrustNum).toFixed(4)}} </div>
						</div>
						<div class="list-line flex-center-between">
							<div  class="label">{{i18n.t('trade.th27')}}</div>
							<div>{{formatOrderDateTime(detailData.CreatedAt)}} </div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th2')}}</div>
							<div>{{parseFloat(detailData.Close).toFixed(4)}} USDT</div>
						</div>
						
					
						<div class="list-line flex-center-between">
							<div  class="label">{{i18n.t('trade.th5')}}</div>
							<div>{{parseFloat(detailData.CloseNum).toFixed(4)}} {{detailData.Currency.ShortName}}</div>
						</div>

						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th28')}}</div>
							<div>{{formatOrderDateTime(detailData.UpdatedAt)}}</div>
						</div>

						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th3')}}</div>
							<div>{{parseFloat(detailData.CloseCount).toFixed(4)}} USDT</div>
						</div>
				
						<div class="list-line flex-center-between">
							<div  class="label">{{i18n.t('trade.th17')}}</div>
							<div class="status clear" :class="detailData.Status == 2 ? 'red' : 'green'">{{detailData.Status == 0 ? i18n.t('trade.status1') : (detailData.Status == 1 ?  i18n.t('trade.status2') :  i18n.t('trade.status3'))}}</div>
						</div>
					</div>
				</div>

				<!--合约-->
				<div class="trade-list black" v-if="tabIndex == 3">
					<div class="list" >
						<div class="flex-center-between">
							<div class="list-title flex-center-start">
								<span>{{detailData.Currency.ShortName}}/USDT</span>
								<span class="tab" :class="[detailData.Direction == 'long' ? 'green' : 'red', i18n.t('trade.label21').length > 10 ? 'small' : '']">{{detailData.Trust == 'limit' ? i18n.t('trade.label22') : i18n.t('trade.label21')}}-{{detailData.Direction == 'long' ? i18n.t('trade.buy2') : i18n.t('trade.sell2')}}</span>
								<span class="tab yellow" :class="i18n.t('trade.label1').length > 12 ? 'small' : ''">{{detailData.Full == 'full' ? i18n.t('trade.label1') : i18n.t('trade.label2')}} {{detailData.Multiple}}X</span>
							</div>
							<!-- <div class="status" :class="detailData.Status == 2 ? 'red' : 'green'">{{detailData.Status == 0 ? i18n.t('trade.status1') : (detailData.Status == 1 ? i18n.t('trade.status4') : i18n.t('trade.status5'))}}</div> -->
						</div>
			
					
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th11')}}</div>
							<div>{{parseFloat(detailData.OpenNum).toFixed(4)}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th9')}}</div>
							<div>{{parseFloat(detailData.TrustClose).toFixed(4)}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th10')}}</div>
							<div>{{parseFloat(detailData.OpenClose).toFixed(4)}}</div>
						</div>
					
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th12')}}</div>
							<div>{{getContractClose(detailData.OpenClose, detailData.Multiple, detailData.Direction)}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th8')}}</div>
							<div>{{(detailData.OpenClose * detailData.OpenNum / detailData.Multiple).toFixed(4)}}</div>
						</div>

						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th7')}}</div>
							<div class="flex-center">
								{{parseFloat(detailData.Margin).toFixed(4)}}
							</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th26')}}</div>
							<div class="flex-center">
								<span class="green">{{parseFloat(detailData.TakeProfit) || '--'}}</span>
								<span> / </span>
								<span class="red">{{parseFloat(detailData.StopLoss) || ' --'}}</span>
							</div>
						</div>

					</div>
				</div>

				<div class="trade-list" v-if="tabIndex == 2">
					<div class="list" >
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th16')}}</div>
							<div>{{detailData.Currency.ShortName}}/USDT</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th17')}}</div>
							<div class="label" :class="detailData.Status == 2 ? 'red' : 'green'">{{detailData.Status == 0 ? i18n.t('trade.status6') : (detailData.Status == 1 ? i18n.t('trade.status7') : i18n.t('trade.status8'))}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th18')}}</div>
							<div class="label">{{formatOrderDateTime(detailData.CreatedAt)}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th19')}}</div>
							<div class="label">{{detailData.MarkPrice}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th20')}}</div>
							<div class="label">{{formatOrderDateTime(detailData.SettlementTime)}}</div>
						</div>
						<div class="list-line flex-center-between" v-if="detailData.Status == 1">
							<div class="label">{{i18n.t('trade.th21')}}</div>
							<div class="label">{{detailData.SettlementPrice}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th22')}}</div>
							<div class="label" :class="detailData.Direction == 'rose' ? 'green' : 'red'">{{detailData.Direction == 'rose' ? i18n.t('trade.buy4') : i18n.t('trade.sell4')}}</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th23')}}</div>
							<div class="label">{{detailData.Settlement}}S</div>
						</div>
						<div class="list-line flex-center-between">
							<div class="label">{{i18n.t('trade.th24')}}</div>
							<div class="label">{{detailData.Amount}} USDT</div>
						</div>
						<div class="list-line flex-center-between" v-if="detailData.Status == 1">
							<div class="label">{{i18n.t('trade.th25')}}</div>
							<div class="label" :class="detailData.Profit > 0 ? 'green' : 'red'">{{detailData.Profit}}</div>
						</div>
					</div>
				</div>


			<div class="order-empty empty-box flex-column-center" v-if="orderList.length == 0 && isInit">
				<img :src="emptyUrl" alt="">
				<span>{{i18n.t('common.empty')}}</span>
			</div>
		</div>
		<!--平仓-->
		<Popup v-model:show="showClearPage" position="bottom" lock-scroll class="rate-popup">
			<clear-page :bitInfo="bitInfo" :orderData="orderdetailData" @cancel="cancel" @submit="submitClear"></clear-page>
		</Popup>
		<!--二次确认弹框-->
		<Popup v-model:show="showEnsureModal" position="center" lock-scroll class="ensure-popup">
			<div class="ensure-modal flex-column-center">
				<div class="title" v-if="ensureType == 'option'">{{i18n.t('trade.desc32')}}</div>
				<div class="title" v-if="ensureType == 'cancel' || ensureType == 'cancelContract'">{{i18n.t('trade.desc33')}}</div>
				<div class="flex-center btn-line">
					<Button class="gray" @click.stop="cancel">{{i18n.t('trade.btn1')}}</Button>
					<Button @click.stop="ensureAction">{{i18n.t('trade.btn2')}}</Button>
				</div>
			</div>
		</Popup>
	</div>
</template>
<script>
import { optionOrderList, spotList, contractList, cancelSpotOrder, contractLiquidation } from '@/api/trade'
import topBar from '@/components/topBar'
import { List, Button, Popup } from 'vant'
import clearPage from '../trade/clear'
import { formatServerTimeEn } from '@/utils/timeUtils'
export default {
	components: {
		topBar,
		List,
		Button,
		Popup,
		clearPage
	},
	props: {
		bitInfo: Object
	},
  data() {
		return {
			form: {
				status: ''
			},
			tabIndex: 1,
			downUrl: require('../../assets/imgs/icon-arrow-down.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			emptyUrl: require('../../assets/imgs/order-empty.png'),
			clearUrl: require('../../assets/imgs/icon-clear.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
			tabList: [this.i18n.t('allOrder.tab1'), this.i18n.t('allOrder.tab2'), this.i18n.t('allOrder.tab3')],
			orderList: [],
			isInit: false,
      loading: false,
      finished: false,
			page: {
				page: 1,
				pageSize: 10
			},
			totalPage: 1,
			showOption: false,
			statusName: this.i18n.t('allOrder.status1'),
			statusList: [
				{
					text: this.i18n.t('allOrder.status1'),
					value: ''
				},
				{
					text: this.i18n.t('allOrder.status2'),
					value: '0'
				},
				{
					text: this.i18n.t('allOrder.status3'),
					value: '1'
				},
				{
					text: this.i18n.t('allOrder.status4'),
					value: '2'
				},
			],
			showClearPage: false,
			orderdetailData: {},
			detailData: {
				Currency: {}
			},
			showEnsureModal: false,
			ensureType: ''
		}
	},
	mounted() {
		this.tabIndex = this.$route.query.type || 1
		let data = 	sessionStorage.getItem('orderDetailData')
		if (data) {
			this.detailData = JSON.parse(data)
		}
	},
	methods: {
		formatOrderDateTime(time) {
			if (!time) return '--'
			return formatServerTimeEn(time, 'YYYY-MM-DD hh:mm:ss A')
		},
		back() {
			this.$router.go(-1)
		},
		chooseOption() {
			this.showOption = !this.showOption
		},
		toClearOrder(data) {
			this.orderdetailData = data
			this.showClearPage = true
		},
		cancel() {
			this.showClearPage = false
		},
		cancelOrder(data) {
			this.showEnsureModal = true
			this.ensureParam = data
			this.ensureType = 'cancel'
		},
		doCancelOrder(data) {
			let form = new FormData()
			form.append('ID', data.ID)
			cancelSpotOrder(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success2'))
					this.detailData.Status = 2
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		cancel() {
			this.showEnsureModal = false
		},
		ensureAction() {
			this.showEnsureModal = false
			if (this.ensureType == 'cancel') {
				this.doCancelOrder(this.ensureParam)
			} else if (this.ensureType == 'option') {
				this.doSubmitOption()
			} else if (this.ensureType == 'cancelContract') {
				this.doCancelContract(this.ensureParam)
			}
		},
		submitClear(data) {
			let form = new FormData()
			form.append('ID', this.orderdetailData.ID)
			form.append('PlanTrust', data.type == 1 ? 'market' : 'limit')
			form.append('PlanTrustNum', data.number)
			form.append('PlanTrustPrice', data.price)
			contractLiquidation(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('trade.success3'))
					this.showClearPage = false
					this.page.page = 1
					this.initOrder()
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		getContractClose(close, multiple, type) {
			if (type == 'long') {
				return parseFloat((close * (1 - 1 / multiple)).toFixed(4))
			} else {
				return parseFloat((close * (1 + 1 / multiple)).toFixed(4))
			}
		}
	}
}
</script>